import { Component, OnInit, ViewChild, ElementRef, TemplateRef } from '@angular/core';
import { Router } from '@angular/router';
import { Authentication, loginRegisterModel, RequestBody, RequestHeader, UserDetails, UserRQ } from '../Model/loginRegisterModel';
import { AccountService } from '../Service/account.service';
import { BsModalRef, BsModalService, ModalOptions } from 'ngx-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { OwlOptions } from 'owl.carousel';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { CompanySettingService } from '../Service/company-setting.service';
import { CommonService } from '../Service/common.service';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css']
})
export class LoginComponent implements OnInit {
  msg: string;
  currentYear: number = new Date().getFullYear();
  config: ModalOptions = { class: 'modal-dialog' };
  loginModel: loginRegisterModel;
  forgotModel: loginRegisterModel;
  loader: boolean;
  modalRef: BsModalRef;
  CustomOptions: OwlOptions = {
    items: 6,
    dots: false,
    navigation: true,
    autoplay: true,
    pagination: true,
    responsive: {
      0: {
        items: 1
      },
      600: {
        items: 1
      },
      980: {
        items: 2
      },
      1199: {
        items: 6
      }
    },
    nav: true
  }
  CustomOptions1: OwlOptions = {
    items: 6,
    dots: false,
    navigation: true,
    autoplay: true,
    pagination: true,
    responsive: {
      0: {
        items: 1
      },
      600: {
        items: 1
      },
      980: {
        items: 2
      },
      1199: {
        items: 6
      }
    },
    nav: true
  }
  @ViewChild("loginbtn", { static: false }) loginbtn: ElementRef;
  @ViewChild("ModalPopup", { static: false }) modalPopup: TemplateRef<any>;
  CompanySetting = CompanySettingService;
  wronginp = "Please enter a valid username and EmailId";
  constructor(
    private readonly commonService: CommonService,
    private accountService: AccountService,
    private router: Router,
    private modalService: BsModalService,
    private toastr: ToastrService
  ) { }

  form = new FormGroup({
    username: new FormControl('', [
      Validators.required,
      Validators.minLength(2),
      Validators.maxLength(60),
      Validators.pattern(/^[a-zA-Z 0-9.@]*$/),
    ],),
    email: new FormControl('', [Validators.required, Validators.email])
  });

  ngOnInit() {
    sessionStorage.clear();
    localStorage.clear();
    this.loginModel = new loginRegisterModel();
    this.loginModel.UserRQ = new UserRQ();
    this.loginModel.UserRQ.Authentication = new Authentication();
    this.loginModel.UserRQ.RequestHeader = new RequestHeader();
    this.loginModel.UserRQ.RequestHeader.Method = "B2BLogin";
    this.loginModel.UserRQ.RequestBody = new RequestBody();
    this.loginModel.UserRQ.RequestBody.UserDetails = new UserDetails();
    this.forgotModel = new loginRegisterModel();
    this.forgotModel.UserRQ = new UserRQ();
    this.forgotModel.UserRQ.Authentication = new Authentication();
    this.forgotModel.UserRQ.RequestHeader = new RequestHeader();
    this.forgotModel.UserRQ.RequestBody = new RequestBody();
    this.forgotModel.UserRQ.RequestBody.UserDetails = new UserDetails();
  }

  myFormSubmitHandler() {
    let el: HTMLElement = this.loginbtn.nativeElement;
    el.click();
  }

// for login password
  LoginUser(valid) {
    if (valid) {
      this.loader = true;
      this.loginModel.UserRQ.RequestBody.UserDetails.LoginType = 'subagent';
      this.loginModel.UserRQ.RequestBody.UserDetails.ClientId = 0;
      this.loginModel.UserRQ.RequestBody.UserDetails.IsWhiteLabel = 'false';
      this.accountService.login(this.loginModel).subscribe(data => {
        
        var alldata = data as any;
        if (alldata.UserRS.ResponseHeader == null || alldata.UserRS.ResponseHeader.Status != "SUCCESS") {
          this.loader = false;
          // window.alert("Wrong Username/Password.");
          this.toastr.error("Please Enter Correct Username / Password.");
          return false;
        }
        else if (alldata.UserRS.ResponseHeader.Status == "SUCCESS") {
          localStorage.setItem("token", alldata.UserRS.ResponseBody.AgentDetails.SubagentID);
          localStorage.setItem("UserDetails", JSON.stringify(alldata.UserRS.ResponseBody.AgentDetails));
          const nameParts = alldata.UserRS.ResponseBody.AgentDetails.UserName.trim().split(' ');
          if (nameParts.length > 0) {
            localStorage.setItem("UserName", nameParts[0] + ' ' + nameParts[nameParts.length - 1]);
           }
          
          
          this.router.navigate(['flight'])
          this.toastr.success("Submitted Username/Password.");
          return true;
        }
        else {
          this.loader = false;
          this.toastr.success(alldata.UserRS.ResponseHeader.Message || "Something went wrong.");
        }
      }, err => {
        this.loader = false;
        this.toastr.error("Wrong Username/Password.")
      })

    }
  }

  
  onSubmit(): void {
    if (this.form.invalid) {
      this.wronginp;
      return;
    }
    this.commonService.ForgotPass(this.forgotModel).subscribe(
      (response: any) => {
        if (response.UserRS.ResponseHeader.Status === 'SUCCESS') {
          this.toastr.success('Forgot Password successful!');
          this.modalRef.hide();
        }
        else
          this.toastr.error("Failed to Forgot Password.");
        this.form.reset();
       /* this.msg = "Please enter a valid username and EmailId";*/
      },

      error => {
        this.toastr.error("Failed to Forgot Password.")
       /* this.msg = "Please enter a valid username and EmailId";*/
      }
    );
   
  }

  getTitleAndLastName(fullName: string): string {
    if (!fullName) return '';

    const parts = fullName.trim().split(' ');
    if (parts.length < 2) return fullName; // e.g., only "Mr" or "Singh"

    const title = parts[0]; // e.g., "Mr"
    const lastName = parts[parts.length - 1]; // e.g., "Singh"
    return `${title} ${lastName}`;
  }
  ForgotPassword() {
    this.modalRef = this.modalService.show(this.modalPopup, this.config);
  }
  // onSubmit() {
  //   this.toastr.success("Forgot Password successfully");
  //   this.form.reset();
  // }
}
